/**
 * Piezas de las pantallas de Documentos que no son componentes (fuera de los
 * `.tsx` para que el fast refresh de Vite siga funcionando en ellos).
 */

const PATRON = /\{\{\s*([a-z_]+(?:\.[a-z0-9_]+)?)\s*\}\}/g

/**
 * Una plantilla puede traer `{{clave}}` como texto suelto (un ejemplo, o una
 * creada por la API): se convierte en chip al abrirla, para que se vea y se
 * borre igual que los insertados desde el menú.
 */
export function aChips(html: string): string {
  const sinSpans = html.replace(/<span[^>]*data-variable="([^"]+)"[^>]*>[^<]*<\/span>/g, '{{$1}}')
  return sinSpans.replace(PATRON, (_m, clave: string) => `<span data-variable="${clave}">{{${clave}}}</span>`)
}

/** «Nombre de la capacitación» → `nombre_de_la_capacitacion`: lo que va en `{{envio.…}}`. */
export function claveDesdeRotulo(rotulo: string, usadas: string[]): string {
  const base = rotulo.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase()
    .replace(/[^a-z0-9]+/g, '_').replace(/^_+|_+$/g, '').replace(/^[^a-z]+/, '').slice(0, 36) || 'campo'
  let clave = base
  for (let i = 2; usadas.includes(clave); i++) clave = `${base}_${i}`
  return clave
}

export const ESTADOS_ENVIO = {
  queued: { label: 'En cola', tone: 'neutral' },
  running: { label: 'Generando', tone: 'info' },
  done: { label: 'Terminado', tone: 'success' },
  failed: { label: 'Incompleto', tone: 'warning' },
} as const
